import type { Type } from '../../type'

window.$ = window.jQuery = require('jquery')

import 'es6-promise/auto.js'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

import 'bootstrap-filestyle/src/bootstrap-filestyle.min.js'

import '@fortawesome/fontawesome-free/css/all.min.css'

import 'air-datepicker/dist/js/datepicker.min.js'
import 'air-datepicker/dist/js/i18n/datepicker.en.js'
import 'air-datepicker/dist/css/datepicker.min.css'

import 'animate.css/animate.min.css'

import 'bootstrap-select/dist/js/bootstrap-select.min.js'
import 'bootstrap-select/dist/css/bootstrap-select.min.css'

import 'bootstrap-notify/bootstrap-notify.min.js'

import 'bootstrap-timepicker/js/bootstrap-timepicker.min.js'
import 'bootstrap-timepicker/css/bootstrap-timepicker.min.css'

import 'bootswatch/dist/sandstone/bootstrap.min.css'

import 'floatthead/dist/jquery.floatThead.min.js'

import 'jquery-deparam'

import 'jquery-bootstrap-theme/css/custom-theme/jquery-ui-1.10.3.custom.css'

import 'magnific-popup/dist/jquery.magnific-popup.min.js'
import 'magnific-popup/dist/magnific-popup.css'

import 'progressbar.js/dist/progressbar.min.js'

import 'pure-css-loader/dist/css-loader.css'

import 'quill/dist/quill.snow.css'

import 'tablesorter/dist/js/jquery.tablesorter.min.js'

import '../../client/light-table-filter.min.js'

import 'sortablejs/Sortable.min.js'

import './style/*.styl'
import './style/*/*.styl'

window.App = {
	Coupon : require('./client/coupon').default,
	Login  : require('./client/login').default,
	Style  : require('./client/style').default,
	Stylist: require('./client/stylist').default,

	common: {
		Helper : require('../../client/helper').default,
		Is     : require('../../client/is').default,
		Log    : require('../../client/log').default,
		Network: require('../../client/network').default,
		Ui     : require('../../client/ui').default,
	},
}

$(() =>
{
	//@ts-ignore
	$.fn.datepicker.language['ja'] = {
		days       : ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
		daysShort  : ['日', '月', '火', '水', '木', '金', '土'],
		daysMin    : ['日', '月', '火', '水', '木', '金', '土'],
		months     : ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
		monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
		today      : '今日',
		clear      : '消去',
	}

	window.App.common.Ui.init()
	window.App.common.Network.init()
})

declare global
{
	//noinspection JSUnusedGlobalSymbols
	interface Window
	{
		App:Type.hash<any>
		$:JQuery
		jQuery:JQuery
		LightTableFilter:LightTableFilter
	}

	interface JQuery
	{
		datepicker(option?:Type.hash<any>):void

		timepicker(option?:Type.hash<any>):void

		tablesorter(option?:Type.hash<any>):void

		floatThead(option?:Type.hash<any>):void

		filestyle(option?:Type.hash<any>):void

		magnificPopup(option?:Type.hash<any>):void

		selectDate(date:Date):void
	}

	//noinspection JSUnusedGlobalSymbols
	interface JQueryStatic
	{
		notify({}, {}?):void

		deparam(string:string):Type.hash<any>
	}

	interface LightTableFilter
	{
		init():void
	}
}
